<template>
  <button
    v-bind="$attrs"
    class="flex items-center justify-center gap-2 rounded-lg"
    :class="{
      [variant]: variant,
      'text-xs': size === 'sm',
      'text-sm': size === 'md',
      'text-base': size === 'lg',
      'flex-row': iconPosition === 'right',
      'flex-row-reverse': iconPosition === 'left',
      'px-4 py-2': text,
      'p-2': !text,
      'p-2.5': icon && !text && size === 'lg',
      'border-none': !text && variant === 'tertiary',
    }"
  >
    <p v-if="text" :class="{ 'font-semibold': highLight }">{{ text }}</p>
    <ImoIcon v-if="icon" :size="Number(iconSize)" :name="icon" />
  </button>
</template>

<script>
export default {
  name: 'ImoTextButton',
  props: {
    variant: {
      type: String,
      validators: value => ['primary', 'secondary', 'tertiary'].includes(value),
      default: 'primary',
    },
    size: {
      type: String,
      validators: value => ['sm', 'md', 'lg'].includes(value),
      default: 'md',
    },
    text: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    iconPosition: {
      type: String,
      validators: value => ['left', 'right'].includes(value),
      default: 'right',
    },
    highLight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconSize() {
      if (this.icon) {
        return this.size === 'sm' ? '16' : this.size === 'md' ? '20' : '22'
      }
      return false
    },
  },
}
</script>

<style scoped>
@reference "@/assets/style/main.css";

.primary {
  @apply text-primary-90 hover:bg-primary-0 disabled:text-primary-10 disabled:pointer-events-none;
}

.secondary {
  @apply text-secondary-50 hover:bg-secondary-0 hover:text-secondary-60 disabled:text-secondary-20 disabled:pointer-events-none;
}
</style>
